import {
    Component,
    input,
    model,
    output,
    ViewEncapsulation,
} from '@angular/core';
import { FormsModule } from '@angular/forms';
import { Button } from 'primeng/button';
import { Dialog } from 'primeng/dialog';
import { InputText } from 'primeng/inputtext';
import { Editor } from 'primeng/editor';
import { LegalDocView } from './legal-doc-view';
import { LegalTemplateVariablesHint } from './legal-template-variables-hint';

/**
 * Popup editor for one legal document: variables hint + title + rich-text
 * content on the left, live validated preview on the right. The dialog is
 * resizable; the editor and the preview stretch with it. Shared by the
 * category legal form and the realm Legal tab — the host owns the
 * title/content state and applies it on (apply).
 */
@Component({
    selector: 'app-legal-doc-edit-dialog',
    standalone: true,
    imports: [
        FormsModule,
        Button,
        Dialog,
        InputText,
        Editor,
        LegalDocView,
        LegalTemplateVariablesHint,
    ],
    templateUrl: './legal-doc-edit-dialog.html',
    // The dialog is appended to <body>, outside this component's emulated
    // encapsulation scope — styles must be global, scoped by the styleClass.
    encapsulation: ViewEncapsulation.None,
    styles: `
        /* PrimeNG 21: .p-editor-toolbar and .p-editor-content are direct
           children of the p-editor host — stretch only the content area. */
        .legal-edit-dialog p-editor {
            display: flex;
            flex-direction: column;
            height: 100%;
        }
        .legal-edit-dialog p-editor .p-editor-toolbar {
            flex: 0 0 auto;
        }
        .legal-edit-dialog p-editor .p-editor-content {
            flex: 1 1 0;
            min-height: 8rem;
            overflow: auto;
        }
    `,
})
export class LegalDocEditDialog {
    readonly header = input('');
    readonly visible = model.required<boolean>();
    readonly title = model.required<string>();
    readonly content = model.required<string>();

    /** Emitted before the dialog closes; the host applies title/content. */
    readonly apply = output<void>();

    protected close(): void {
        this.visible.set(false);
    }

    protected onApply(): void {
        this.apply.emit();
        this.visible.set(false);
    }
}
